import React from 'react'
import ReactDOM from 'react-dom'
import dateFormat from 'dateformat'
import moment from 'moment'

import { BOOKING, BookingContext } from '../bookings/BookingContext'
import { BOOKING_STATES } from '../helpers/bookingHelper'
import { fetchBooking } from '../helpers/hotelHelper'
import { cancelBooking } from '../api/booking'

import Loading from '../common/Loading'

const BookingCancelModal = (props) => {
  const { state, dispatch } = React.useContext(BookingContext)
  const [updateRequestPayload, setUpdateRequestPaylaod] = React.useState({})

  const _closeModal = () => {
    dispatch({ type: BOOKING.CANCELLATION.SET, payload: null })
  }

  const __getBooking = async (payload) => {
    dispatch({ type: BOOKING.LOADING, payload: true })
    const data = await fetchBooking(payload)

    if (data && data.booking) {
      dispatch({ type: BOOKING.LOADING, payload: false })
      dispatch({ type: BOOKING.SET, payload: data.booking })
    }
  }

  const _cancelBooking = () => {
    dispatch({ type: BOOKING.LOADING, payload: true })
    cancelBooking(state.cancellation.id).then((response) => {
      setUpdateRequestPaylaod({
        ...response.data
      })
      dispatch({ type: BOOKING.LOADING, payload: true })
      dispatch({type: BOOKING.UPDATE, payload: { ...state.cancellation, status: BOOKING_STATES.CANCELLATION_REQUESTED }})
      __getBooking(state.cancellation)
    }).finally(() => {
      dispatch({ type: BOOKING.LOADING, payload: false })
    })
  }

  const _convertDate = (date) => {
    let newDate = new Date(date)
    return moment.parseZone(newDate).format('HH:mm on MM/DD/YYYY')
  }

  const _formatDate = date => dateFormat(
    new Date(date),
    'UTC:mm/dd/yyyy'
  )

  const renderCancellationPolicyForRoom = (cancellationPolicies) => {
    return cancellationPolicies.map((policy, i) => {
      return (
        <div className="cancellation-price-wrapper" key={i}>
          <div className="cancellation-duration"><span className="sub-heading"><b>After</b> {_convertDate(policy.from)}</span></div>
          <div className="cancellation-amount"><span className="sub-heading">${policy.amount}</span></div>
        </div>
      )
    })

  }

  const renderCancellationPolicies = () => {
    if (Array.isArray(state.cancellation.cancellation_policies)) {
      return renderCancellationPolicyForRoom(state.cancellation.cancellation_policies)
    } else {
      let policies = Object.keys(state.cancellation.cancellation_policies).map((room, idx) => {
        return (
          <div key={idx}>
            <h3>{room}</h3>
            {renderCancellationPolicyForRoom(state.cancellation.cancellation_policies[room])}
          </div>
        )
      })

      return <>{policies}</>
    }
  }

  const getContent = () => {
    if (updateRequestPayload.success)
      return <p>{updateRequestPayload.message}</p>
    return (
      <div className="cancellation-dialog">
        <p>Just to confirm, you are about to cancel this booking:</p>
        <div className="booking-cancellation-details">
          <span className="title">
            <i className="fas fa-bed" />
            &nbsp;{state.cancellation.property} in {state.cancellation.destination}
          </span>
          <span className="sub-heading">
            <i className="fas fa-user" />
            &nbsp;{state.cancellation.first_name} {state.cancellation.last_name}
          </span>
          <span className="sub-heading">
            {_formatDate(state.cancellation.arrival)} <i className="fas fa-long-arrow-alt-right" /> {_formatDate(state.cancellation.departure)}
          </span>
          {state.cancellation.lodging_confirmation_code && (
          <span className="sub-heading"><strong>Confirmation Code:</strong> {state.cancellation.lodging_confirmation_code}</span>
          )}
        </div>

        <p>The following cancellation fees will be assessed:</p>
        <div className="cancellation-prices">
          {renderCancellationPolicies()}
        </div>

        {state.isLoading && <Loading />}
      </div>
    )
  }

  let body = (
    <div className={`modal current-area bottom amenities ${props.open ? 'show' : 'hide' }`}>
      <div className="overlay"></div>
      <div className="modal_content">
        <h2 className="modal_title">Cancellation Request</h2>
        <div className="row">
          {getContent()}
        </div>
        <div className="row" style={{'textAlign': 'right'}}>
          {!updateRequestPayload.success && <a className="button secondary" onClick={_cancelBooking} disabled={state.isLoading}>Cancel Booking</a>}
          <a className="button primary" onClick={_closeModal} disabled={state.isLoading}>Dismiss</a>
        </div>
        <button title="Close" className="close_modal" onClick={_closeModal} disabled={state.isLoading}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  )

  return ReactDOM.createPortal(
    body,
    document.getElementById('modal')
  )
}

export default BookingCancelModal
